// ── Same file, different folder (2026-09-28) ─────────────────────────────────
// A file is "the same" when its content fingerprint matches — SharePoint's
// quickXorHash (src/utils/quickXorHash.js computes the same value in the
// browser) — so a renamed copy is still caught. Used by the copy into the job
// folder (link to the copy already there instead of copying again) and by
// uploads (warn before saving a file the job folder already has). Pure.
import { entityBasePath, listJobFolders } from "../../utils/sharePoint";
import { jobFolderForNumber } from "./folderPath";

// hash → the job-folder files with that content
export function buildFileIndex(files = []) {
  const index = new Map();
  for (const f of files || []) {
    if (!f?.hash) continue;
    if (!index.has(f.hash)) index.set(f.hash, []);
    index.get(f.hash).push(f);
  }
  return index;
}

// The first job-folder file with this content (skipping the item itself).
export function findDuplicate(index, hash, { excludeId = null } = {}) {
  if (!hash || !index) return null;
  return (index.get(hash) || []).find(f => f.id !== excludeId) || null;
}

export function addToIndex(index, file) {
  if (!file?.hash) return;
  if (!index.has(file.hash)) index.set(file.hash, []);
  index.get(file.hash).push(file);
}

// Where it is, the way people see it: "Contract/Master Agmt.pdf".
export const duplicateLocation = (file) => file?.path || file?.name || "";

export function uploadDuplicatePrompt(fileName, match) {
  const where = duplicateLocation(match);
  const renamed = match?.name && match.name !== fileName ? ` (saved as "${match.name}")` : "";
  return `"${fileName}" is already in the job folder: ${where}${renamed}.\n\nUpload it again anyway?`;
}

// The turnover's job folder: the saved one, else the one folder in the prime
// entity's <year> Jobs whose name starts with the job number — whatever the
// rest of its name is (older folders carry the full deal name, newer ones
// leave the location out; folderPath.js jobFolderName). null when none.
export async function locateJobFolder(token, driveId, turnover) {
  if (turnover?.ConstructionFolderItemId) return { id: turnover.ConstructionFolderItemId, webUrl: turnover.SharePointFolderUrl || null };
  const job = String(turnover?.JobNumber || "").trim();
  if (!job) return null;
  const folders = await listJobFolders(token, driveId, entityBasePath(turnover.ContractingEntity), job.split("-")[0]);
  return jobFolderForNumber(folders, job);
}

export async function findJobFolderId(token, driveId, turnover) {
  return (await locateJobFolder(token, driveId, turnover))?.id || null;
}

// Where the job folder is looked for, for messages: "Allied/2026 Jobs".
export const jobFolderParentFor = (turnover) =>
  `${entityBasePath(turnover?.ContractingEntity)}/${String(turnover?.JobNumber || "").trim().split("-")[0]} Jobs`;
